import { MenuPlacement, Options } from 'react-select'

import { DropdownOption } from 'components/Input/Dropdown'
import {
  StyledAsyncSelect,
  StyledLabel,
  StyledSelectLabelWrapper,
} from './styles'

export interface AsyncDropdownProps {
  name: string
  value?: DropdownOption
  onChange?: (newValue: any) => void
  loadOptions?: (inputValue: string) => Promise<Options<DropdownOption>>
  placeholder?: string
  className?: string
  disabled?: boolean
  showLabel?: boolean
  menuPlacement?: MenuPlacement
  isLoading?: boolean
}

function AsyncDropdown({
  name,
  value,
  onChange,
  loadOptions,
  placeholder,
  className,
  disabled = false,
  showLabel = false,
  menuPlacement = 'bottom',
  isLoading,
}: AsyncDropdownProps) {
  return (
    <>
      {showLabel && value?.value && (
        <StyledSelectLabelWrapper>
          <StyledLabel htmlFor={name}>{placeholder}</StyledLabel>
        </StyledSelectLabelWrapper>
      )}
      <StyledAsyncSelect
        inputId={name}
        placeholder={placeholder}
        classNamePrefix="select"
        className={className}
        name={name}
        value={value?.value ? value : null} // null is a fix for value reset, based on https://github.com/JedWatson/react-select/issues/2931
        onChange={onChange}
        isDisabled={disabled}
        loadOptions={loadOptions}
        menuPlacement={menuPlacement}
        cacheOptions
        isLoading={isLoading}
      />
    </>
  )
}

export default AsyncDropdown
